import React from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';

const CryptoApi = () => {
  const { price, error, isConnecting } = useWebSocket();

  return (
    <div className="crypto-price">
      {error ? (
        <div className="error">{error}</div>
      ) : (
        <div className="price">
          {isConnecting ? (
            <span className="loading">Loading...</span>
          ) : price ? (
            <>
              <span className="currency">BTC now = $</span>
              <span className="amount">{price.toFixed(2)}</span>
            </>
          ) : (
            <span className="loading">Waiting for price...</span>
          )}
        </div>
      )}
    </div>
  );
};

export default CryptoApi;
